import axios from 'axios'
// import { Message } from 'element-ui'
import { isType } from './util'
import { DATA_METHODS, REQUEST_METHODS } from './constant'
import {
  handleParamsError
//   handleStatusError,
//   handleResponseError,
//   handleDataError
} from './error'
import baseURL from '../../config/baseURL'

export const instance = axios.create({
  baseURL,
  method: 'post',
  timeout: 0
  // withCredentials: true
})
// 外部接口数组
// const arr = ['/yzjomc/order/export/excell2', '/space/c/auth/fluxAuth', '/space/c/rest/mycloudhome/myNetworksOpen', '/space/c/community/travel', '/yzjomc/order/flow-list', '/gateway/scc/flow/getAllowanceInfoweb', '/space/c/user/logout']
// 请求拦截处理
instance.interceptors.request.use(config => {
  const method = (config.method || '').toLowerCase()
  if (DATA_METHODS.indexOf(method) === -1) {
    config.params = config.data
    config.data = undefined
  }
  return config
}, error => {
  return Promise.reject(error)
})

// let msgInstance = null
// 响应拦截处理
instance.interceptors.response.use(response => {
  // const { status } = response
  return Promise.resolve(response.data)
  // console.log(response.config.url)
  // 如果是外部接口
  // if (arr.includes(response.config.url)) {
  //   return Promise.resolve(response.data)
  // } else {
  //   if (status !== 200) {
  //     return handleStatusError(status)
  //   }
  //   const { status: state, message, responseBody } = response.data
  //   if (parseInt(state) !== 1 || !responseBody) {
  //     return handleResponseError(state, message)
  //   }
  //   const { success, message: msg, data, errorCode } = responseBody
  //   if (!success) {
  //     // 清除上一个msg
  //     msgInstance && msgInstance.close()
  //     msgInstance = Message({
  //       message: msg,
  //       type: 'warning',
  //       offset: 250,
  //       center: true
  //     })
  //     return handleDataError(errorCode, msg)
  //   }
  //   return Promise.resolve(data)
  // }
}, error => {
  return Promise.reject(error)
})

/**
 * 发起网络数据请求
 * @param {String} url 请求地址
 * @param {String} method 请求方法
 * @param {Object} data 请求参数
 * @param {Object} options 额外配置参数
 * @return {Promise} 成功回调
 */
function request (url, method = 'get', data = {}, options = {}) {
  const params = {}
  if (typeof url === 'string') {
    if (typeof method === 'string') {
      Object.assign(params, {
        url,
        method,
        data
      }, options)
    } else if (isType(method) === 'Object') {
      Object.assign(params, {
        url,
        method: 'get',
        data: options
      })
    } else {
      return handleParamsError()
    }
  } else if (isType(url) === 'Object') {
    Object.assign(params, url)
  } else {
    return handleParamsError()
  }
  if (process.env.NODE_ENV !== 'production') {
    // debugger
    // console.log(process.env.NODE_ENV)
    // params.data.ticket = 'APPURLWITHTICKET08dfcb11288d630375858cc4616d5a3d'
  }
  return instance(params)
}

/**
 * @example
 *  request.get('http://www.baidu.com', { username: 'Echo' })
 */
REQUEST_METHODS.forEach(method => {
  request[method] = function (url, data = {}, options = {}) {
    const params = {}
    if (typeof url === 'string') {
      Object.assign(params, {
        url,
        data
      }, options)
    } else if (isType(url) === 'Object') {
      Object.assign(params, url)
    } else {
      return handleParamsError()
    }
    params['method'] = method
    return request(params)
  }
})

export function get (params) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'GET',
      url: baseURL + params.url + '?' + params.query,
      params: params.params
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
/**
  * post方法，对应post请求
  * @param {String} url [请求的url地址]
  * @param {Object} params [请求时携带的参数]
  */
export function post (params) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'POST',
      url: baseURL + params.url,
      data: params.data,
      headers: params.headers,
      params: params.params
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}

export default request



// WEBPACK FOOTER //
// ./src/plugins/request/index.js